import React, { useEffect } from 'react';
import CustomDialog from '../../sharedcomponents/dialog/dialog';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
import { Box, Checkbox } from '@mui/material';
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { createState, useState } from '@hookstate/core';
import Helper from '../../utility/helper';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
// import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
// import moment from 'moment';
// import { ScheduleUserType } from '../../constants/Constant';
// import TimeSelector from '../../sharedcomponents/timeSelector/timeSelector';

const settingSate = createState({
    isEmail: true,
    isPush: true,
    isBlast: true
});

const NotificationSetting = (props) => {
    const state = useState(settingSate);
    const [isLoading, setIsLoading] = React.useState(false);
    const [agentUserID, setAgentUserID] = React.useState();
    const handleCancel = () => {
        props.handleClose()
        resetState()
    }
    useEffect(() => {
        //console.log(state.isEmail.get(), state.isPush.get(), state.isBlast.get())
        agentUserData()
        props.participantData &&
            props.participantData.appNotificationSetting &&
            props.participantData.appNotificationSetting.length > 0 ? state.set({
                isEmail: props.participantData.appNotificationSetting[0].isEmail,
                isPush: props.participantData.appNotificationSetting[0].isPush,
                isBlast: props.participantData.appNotificationSetting[0].isBlast
            })
            : null
        if (props.participant && props.participant !== null) {
            getAppNotifications()
        }
        //console.log(state.isEmail.get(), state.isPush.get(), state.isBlast.get())

    }, []);
    const getAppNotifications = () => {
        const eventInfo = Helper.getStorage('eventInfo');
        ApiHelper.get(APIURLConstants.GET_USER_NOTIFICATION_SETTING(eventInfo.eventID, props.participant.userID))
            .then((res) => {
                //console.log(res.data)
                state.set({
                    isEmail: res.data.isEmail,
                    isPush: res.data.isPush,
                    isBlast: res.data.isBlast,
                    NotificationSettingID: res.data.NotificationSettingID
                })
            })
    };

    const agentUserData = () => {
        props.data &&
            props.data.agentProfile &&
            props.data.agentProfile.length > 0 &&
            props.data.agentProfile.map((data) => {
                //console.log("data", data);
                setAgentUserID(data.userID)
            })
    }
    const renderDialogContent = () => {
        return (
            <>
                <Box
                    component="form"
                    sx={{
                        width: '100%',
                    }}>
                    <Box>
                        <Checkbox
                            onChange={(e) => state.set({ ...state.get(), isEmail: e.target.checked })}
                            checked={state.get().isEmail}
                        /> Enable Email Notification
                    </Box>
                    <Box sx={{ width: '100%', marginTop: 1 }}>
                        <Checkbox
                            onChange={(e) => state.set({ ...state.get(), isPush: e.target.checked })}
                            checked={state.get().isPush}
                        /> Enable Mobile Notification
                    </Box>
                    <Box sx={{ width: '100%', marginTop: 1 }}>
                        <Checkbox
                            onChange={(e) => state.set({ ...state.get(), isBlast: e.target.checked })}
                            checked={state.get().isBlast}
                        /> Enable App Notification
                    </Box>
                </Box>
            </>
        );
    };
    const resetState = () => {
        state.isEmail.set(true)
        state.isPush.set(true)
        state.isBlast.set(true)
    }
    const renderDialogActions = () => {
        return (
            <ButtonContainer
                showLoading={true}
                loading={isLoading}
                handleClick={handleClick}
                handleCancel={handleCancel}
                buttonText={'Update'}
            />
        );
    };

    const handleClick = () => {
        const eventInfo = Helper.getStorage('eventInfo');
        const userInfo = Helper.getStorage('userInfo');

        setIsLoading(true);
        let payLoad = {
            userID: props.participantData && props.participantData.userID ? props.participantData.userID : 0,
            connectionID: agentUserID ? agentUserID : 0,
            eventID: eventInfo.eventID,
            isEmail: state.get().isEmail,
            isPush: state.get().isPush,
            isBlast: state.get().isBlast,
            createdBy: userInfo.userID,
            userIDs: props.multiEdit && props.multiEdit !== null ? props.multiEdit.userID : "",
            isAdmin: Helper.isAdminUser(userInfo) ? true : false,
        }
        return ApiHelper.post(APIURLConstants.SAVE_APP_NOTIFICATION_SETTING, payLoad)
            .then(() => {
                props.setSnackBarProps({
                    ...props.snackBarProps,
                    openSnack: true,
                    variant: 'success',
                    message: 'Notification Updated successfully.',
                });
                props.handleClose();
                resetState()
                if (Helper.isAdminUser(userInfo) ||
                    (userInfo.roles && Helper.isEventAdmin(userInfo))) {
                    props.getParticipants();
                }
                else {
                    props.getAgentConnections()
                }
            })
            .catch((err) => {
                console.log(err);
                props.setSnackBarProps({
                    ...props.snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: 'Error while adding activity.',
                });
            });

    };


    return (
        <CustomDialog
            title={'UPDATE NOTIFICATIONS'}
            handleClose={props.handleClose}
            open={props.open}
            fullWidth={true}
            renderContent={renderDialogContent}
            renderActions={renderDialogActions}
        />
    );
};
export default NotificationSetting;
